<template>
  <XField
    :errors="validationErrors(parameters.type)"
    :errorStyle="formFieldsErrorStyle">
    <XInput
      color="secondary"
      :label="$t('common.formFields.' + parameters.type)"
      :labelStyle="labelStyle"
      :inputStyle="validationHasErrors(parameters.type) ? inputCustomStyles: {}"
      :data-vv-name="parameters.type"
      :invalid="validationHasErrors(parameters.type)"
      :optional="isOptional"
      v-model="fieldValue"
      v-validate="emailValidation"
      @blur="validate" />
  </XField>
</template>

<script>
import InputMixin from './InputMixin'

export default {
  mixins: [InputMixin],

  computed: {
    emailValidation () {
      return {
        required: this.parameters.required,
        email: true
      }
    }
  },

  methods: {
    validate () {
      this.$validator.validate(this.parameters.type)
    }
  }
}
</script>
